import { useCallback, useEffect, useState } from 'react';

import SelectProperty from '@/components/builder/properties/Select';

export default function SelectAsyncProperty({ options: loader, useOptions = hookDefaultOptions(loader), ...props }) {
  const [options, setOptions] = useState([])

  const loadOptions = useOptions()

  useEffect(() => {
    loadOptions()
      .then(({ options }) => setOptions(options))
  }, [loadOptions])

  return <SelectProperty {...props}
    options={options}
  />
}

function hookDefaultOptions(loader) {
  return () => useCallback(async (...args) => {
    const options = await loader(...args)
    return { options }
  }, [])
}
